import { ErrorPageProps } from '@checkit/react-components';
import { Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import TopNavbar from '../topNavbar/TopNavbar';

function noOp() { return null; }

export const ErrorPage = (props: ErrorPageProps) => {
  const {errorText} = props;
  return (
    <>
        <TopNavbar handleDrawerToggle={noOp} />
        <div style={{ marginTop: '80px' }}>
          <Box>
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
                <p>{errorText}</p>
            </Alert>
          </Box>
        </div>
    </>
  );
};
